module.exports = __webpack_public_path__ + "static/media/Image-1.0a85a018.png";